export const home = {
  nav: {
    howItWorks: 'How it works',
    calculator: 'Calculator',
    services: 'Services',
    disclaimer: 'Disclaimer',
    customerLogin: 'Customer login',
    adminLogin: 'Admin login',
  },
  hero: {
    badge: 'Driven by referrals',
    title: 'Short-term working capital for growing SMEs',
    subtitle:
      "Find a buddy who already uses Whatzneu Finance and inherit their credibility, without risking your buddy's reputation. Start from ₹1 lakh and grow towards ₹10 lakhs as your repayment history builds.",
    requestCallBack: 'Request a call back',
    howItWorks: 'How it works',
    notice: 'Whatzneu Finance is not a bank or an RBI-registered NBFC.',
    readDisclaimer: 'Read the disclaimer',
  },
  howItWorks: {
    kicker: 'How it works',
    title: 'Built on referrals, not paperwork alone',
    subtitle: 'Access starts with someone who already knows Whatzneu Finance, so you begin with credibility instead of from zero.',
    stepLabel: 'Step {{number}}',
    steps: {
      findBuddy: {
        title: 'Find a buddy',
        description: 'Someone you know who already uses Whatzneu Finance refers you.',
      },
      inherit: {
        title: 'Inherit the credibility',
        description: 'Start with the trust your buddy has already built, not from zero.',
      },
      reputation: {
        title: "Your buddy's reputation stays safe",
        description: "Referring you never puts your buddy's reputation at risk.",
      },
      grow: {
        title: 'Grow with your history',
        description: 'Start from ₹1 lakh and grow towards ₹10 lakhs as your repayment record builds.',
      },
    },
    repaymentTitle: 'Repayment terms',
    repayment: {
      principal: 'Repay principal monthly; interest only on the outstanding balance',
      earlyClosure: 'Close early and pay interest only up to the closure date',
      methods: 'Pay by UPI, cash, or online transfer',
    },
    useCasesTitle: 'Common uses',
    useCases: {
      salary: 'Salary bridge',
      rawMaterials: 'Raw materials',
      workingCapital: 'Working capital',
      inventory: 'Seasonal inventory',
      equipment: 'Equipment repair',
      vendors: 'Vendor payments',
      tax: 'GST & TDS dues',
      campaigns: 'Growth campaigns',
      offSeason: 'Off-season expenses',
    },
  },
  calculator: {
    kicker: 'Calculator',
    title: 'Estimate the monthly interest',
    subtitle: 'Move the sliders to see an illustrative breakdown. These figures are not a quote or an offer.',
    amount: 'Amount',
    rate: 'Monthly interest rate',
    ratePerMonth: '{{value}}% per month',
    tenure: 'Tenure',
    tenureMonths: '{{count}} months',
    monthsShort: '{{count}}m',
    monthlyInterest: 'Monthly interest',
    principal: 'Principal',
    interestOver: 'Interest over {{count}} months',
    totalPayable: 'Total payable',
    cta: 'Request a call back with these figures',
    note: 'Illustrative only. Assumes the full principal stays outstanding for the whole tenure. Not a quote, offer, or indication of approval.',
  },
  services: {
    kicker: 'Services',
    title: 'Beyond working capital',
    subtitle: 'Advisory services to help SMEs run leaner and grow steadily.',
    consultancy: {
      title: 'Business consultancy',
      description: 'Cash-flow analysis, revenue-leak identification, and floor-efficiency reviews for your operations.',
    },
    saas: {
      title: 'SaaS consultation',
      description: 'Choosing, implementing, and automating the right software tools for your domain.',
    },
    exploreAll: 'Explore all services',
  },
  disclaimer: {
    title: 'Important disclaimer',
    points: [
      'Whatzneu Finance is not a bank. It is not a Non-Banking Financial Company (NBFC) or any other lender registered with, or regulated by, the Reserve Bank of India (RBI).',
      'Nothing on this website is an offer, invitation, or solicitation to lend, borrow, invest, or place deposits.',
      'Submitting a request only asks us to contact you. It does not create a commitment from either side. Any arrangement, if made, is a private agreement on separately agreed written terms.',
      'Amounts, rates, tenures, and calculator results shown here are illustrative only. They are not quotes and do not indicate approval.',
      'Referring someone does not make the referrer a guarantor or co-borrower for the person referred.',
      'Please take independent financial and legal advice before entering into any financial arrangement.',
    ],
    englishPrevails: 'If a translation differs from the English text, the English text applies.',
  },
  footer: {
    rights: '© {{year}} Whatzneu. All rights reserved.',
    notice:
      'Whatzneu Finance is not a bank or an NBFC registered with the Reserve Bank of India. Nothing on this site is an offer to lend or to accept deposits. All figures are illustrative.',
  },
  lead: {
    title: 'Request a call back',
    subtitle: 'Share your details and we will get in touch to discuss your requirement',
    summaryTitle: 'Your figures (illustrative)',
    amount: 'Amount',
    rate: 'Interest rate',
    ratePerMonth: '{{value}}% / month',
    tenure: 'Tenure',
    tenureMonths: '{{count}} months',
    monthlyInterest: 'Monthly interest',
    totalPayable: 'Total payable',
    breakdown: 'Principal ({{principal}}) + Interest ({{interest}})',
    firstName: 'First name',
    lastName: 'Last name',
    email: 'Email',
    phone: 'Phone number',
    businessName: 'Business name',
    city: 'City',
    state: 'State',
    amountHelper: 'Between ₹1 lakh and ₹10 lakhs',
    notRobot: 'I am not a robot',
    required: '(Required)',
    privacy:
      'Your details are used only to contact you about this request. Submitting does not create a commitment from either side. Whatzneu Finance is not a bank or an RBI-registered NBFC, and these figures are not an offer or a quote.',
    submit: 'Submit request',
    submitting: 'Submitting…',
    verifyHuman: 'Please confirm that you are not a robot.',
    success: 'Thank you. Our team will contact you shortly.',
    genericError: 'Something went wrong. Please try again.',
    submitError: 'We could not submit your request. Please try again.',
  },
};
